import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

export default function ScenarioButtonDeleteDialog({
  deletionInfo,
  targetType = "scene",
  onCancel,
  onKeepScene,
  onDeleteScene,
}) {
  const open = Boolean(deletionInfo);
  if (!open) return null;

  const targetLabel = deletionInfo.targetSceneLabel;
  const hasOtherIncomingButtons = deletionInfo.hasOtherIncomingButtons;
  const isQuestion = targetType === "question";
  const targetPhrase = isQuestion
    ? `на вопрос «${targetLabel}»`
    : `в сцену «${targetLabel}»`;
  const targetNoun = isQuestion ? "вопрос" : "сцену";

  return (
    <div
      className="app-dialog-backdrop"
      onClick={onCancel}
      role="presentation"
    >
      <div
        className="app-dialog app-dialog--confirm app-dialog--button-delete"
        onClick={(event) => event.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="app-dialog-button-delete-title"
        aria-describedby="app-dialog-button-delete-message"
      >
        <button
          type="button"
          className="app-dialog__close-btn"
          onClick={onCancel}
          aria-label="Закрыть"
        >
          <CloseIcon fontSize="small" />
        </button>

        <div className="app-dialog__body app-dialog__body--confirm">
          <div className="app-dialog__confirm-icon" aria-hidden="true">
            <WarningAmberRoundedIcon fontSize="inherit" />
          </div>
          <h2 className="app-dialog__title" id="app-dialog-button-delete-title">
            Удалить кнопку?
          </h2>
          <p className="app-dialog__message" id="app-dialog-button-delete-message">
            {hasOtherIncomingButtons
              ? `Кнопка ведёт ${targetPhrase}, куда ведут и другие кнопки. Остальные связи сохранятся.`
              : `Кнопка ведёт ${targetPhrase}. Выберите, оставить ${targetNoun} в проекте или удалить её вместе с кнопкой.`}
          </p>
          {deletionInfo.canDeleteScene && deletionInfo.hasChildButtons ? (
            <p className="app-dialog__detail">
              Кнопки внутри этого элемента тоже будут удалены. Другие сцены, к
              которым они ведут, останутся в проекте.
            </p>
          ) : null}

          <div className="app-dialog__actions app-dialog__actions--confirm app-dialog__actions--button-delete">
            <Button
              className="app-dialog__btn app-dialog__btn--cancel"
              onClick={onCancel}
              size="small"
              variant="outlined"
            >
              Отмена
            </Button>
            <Button
              className="app-dialog__btn app-dialog__btn--cancel"
              onClick={onKeepScene}
              size="small"
              variant="outlined"
            >
              {hasOtherIncomingButtons
                ? "Удалить только эту кнопку"
                : `Оставить ${targetNoun} без связи`}
            </Button>
            {deletionInfo.canDeleteScene ? (
              <Button
                className="app-dialog__btn app-dialog__btn--danger"
                color="error"
                variant="contained"
                onClick={onDeleteScene}
                size="small"
              >
                Удалить также {targetNoun}
              </Button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
